export default __webpack_public_path__ + "static/148-b99e84aacb5a5606bbaecace5126569c.jpg";